import client from 'api/client'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useLoading } from 'hooks/UseLoading'
import { useHistory } from 'react-router-dom'
import { Permission } from 'types'

export const useRequestReadAccess = () => {
  const [requestAccess, requestingAccess] = useLoading(client.requestDocAccess)
  const history = useHistory()

  const requestReadAccess = (articleId: string) =>
    requestAccess(articleId, Permission.Read).then((res) => {
      if (res.type === 'success') {
        showToastMessage('Request was sent! 🎉', 'success')
        history.goBack()
      } else {
        showErrorMessageToast('Something went wrong, please try again later')
      }
    })
  return [requestReadAccess, requestingAccess] as const
}
